import z from 'zod';
import moment from 'moment';
export const schemaValid = z.object({
  email: z
    .string()
    .email("Phải là email hợp lệ")
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .refine(
      (value) => value === null || value === "" || z.string().email().safeParse(value).success,
      {
        message: "Phải là email hợp lệ hoặc để trống",
      }
    ).optional(),
  dienthoai: z
    .string()
    .regex(
      /^((\+84|0)(2\d{1,2}[\s]?\d{6,8}|3\d{1}[\s]?\d{3}[\s]?\d{4}|5\d{1}[\s]?\d{3}[\s]?\d{4}|7\d{1}[\s]?\d{3}[\s]?\d{4}|8\d{1}[\s]?\d{3}[\s]?\d{4}|9\d{1}[\s]?\d{3}[\s]?\d{4}))$/,
      "Số điện thoại không hợp lệ. Phải là số Việt Nam (bắt đầu bằng 0 hoặc +84 và gồm 10 số, có thể có khoảng trắng giữa các số)."
    )
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .optional(),
  website: z
    .string()
    .url("Phải là URL hợp lệ")
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .refine(
      (value) => value === null || value === "" || z.string().url().safeParse(value).success,
      {
        message: "Phải là URL hợp lệ hoặc để trống",
      }
    ).optional(),
  toado: z
    .string()
    .regex(
      /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*$/,
      "Tọa độ phải là chuỗi hợp lệ, ví dụ: '21.02, 105.85'."
    ) // Kiểm tra định dạng
    .refine((value) => {
      const [latitude, longitude] = value.split(",").map(Number);
      return (
        longitude >= -180 &&
        longitude <= 180 &&
        latitude >= -90 &&
        latitude <= 90
      );
    }, "Kinh độ phải từ -180 đến 180 và vĩ độ từ -90 đến 90.")
    .or(z.literal("")) // Cho phép chuỗi rỗng
    .nullable() // Cho phép null
    .optional(), // Không bắt buộc
});


export const schemaValidTeacher = z.object({
  email: z
    .string()
    .email("Phải là email hợp lệ")
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .refine(
      (value) => value === null || value === "" || z.string().email().safeParse(value).success,
      {
        message: "Phải là email hợp lệ hoặc để trống",
      }
    ).optional(),
  dien_thoai: z
    .string()
    .regex(
      /^((\+84|0)(2\d{1,2}[\s]?\d{6,8}|3\d{1}[\s]?\d{3}[\s]?\d{4}|5\d{1}[\s]?\d{3}[\s]?\d{4}|7\d{1}[\s]?\d{3}[\s]?\d{4}|8\d{1}[\s]?\d{3}[\s]?\d{4}|9\d{1}[\s]?\d{3}[\s]?\d{4}))$/,
      "Số điện thoại không hợp lệ. Phải là số Việt Nam (bắt đầu bằng 0 hoặc +84 và gồm 10 số, có thể có khoảng trắng giữa các số)."
    )
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .optional(),
  ho_ten: z
    .string()
    .min(1, "Họ tên không được để trống")
    .max(100, "Họ tên không được vượt quá 100 ký tự")
    .optional(),
  so_cmnd: z
    .string()
    .regex(/^\d{9}(\d{3})?$/, "Số CMND phải gồm 9 chữ số hoặc số CCCD phải gồm 12 chữ số")
    .optional(),
  ngay_sn: z
    .union([
      z.string().regex(
        /^\d{2}\/\d{2}\/\d{4}$/,
        "Ngày sinh phải theo định dạng DD/MM/YYYY"
      ).refine((value) => moment(value, "DD/MM/YYYY", true).isValid(), "Ngày sinh không hợp lệ"),
      z.string().regex(
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/,
        "Ngày sinh phải theo định dạng ISO 8601"
      ).refine((value) => moment(value, moment.ISO_8601, true).isValid(), "Ngày sinh không hợp lệ"),
      z.date()
    ])
    .optional(),
  ho_khau: z.string().optional(),
  tobm_id: z.number().int().optional(),
  gioi_tinh: z.number().optional(),
  chucvu_id: z.number().optional(),
});

export const schemaValidLopHoc =
  z.object({
    ten_lophoc: z.string().min(1, 'Tên lớp học không được để trống'),
    so_nam: z.number().min(0, 'Số nam phải lớn hơn hoặc bằng 0').optional(),
    so_nu: z.number().min(0, 'Số nữ phải lớn hơn hoặc bằng 0').optional(),
    so_dienchinhsach: z.number().min(0, 'Số chính sách phải lớn hơn hoặc bằng 0').optional(),
    so_canngheo: z.number().min(0, 'Số cận nghèo phải lớn hơn hoặc bằng 0').optional(),
    chunhiem_id: z.number().nullable().optional()
  });

export const schemaValidNhomQuyen =
  z.object({
    ma_nhomquyen: z.string().min(1, 'Mã nhóm quyền không được để trống').default(''),
    ten_nhomquyen: z.string().min(1, 'Tên nhóm quyền không được để trống').default(''),
    mo_ta: z.string().nullable().optional(),
    is_macdinh: z.boolean().optional()
  });

export const schemaValidChangePassword = z.object({
  old_password: z.string().min(8, "Mật khẩu cũ phải có ít nhất 8 ký tự"),
  new_password: z.string()
    .min(8, { message: "Mật khẩu phải có ít nhất 8 ký tự" })
    // .regex(/[A-Z]/, { message: "Mật khẩu phải chứa ít nhất một chữ cái viết hoa" })
    .regex(/[a-z]/, { message: "Mật khẩu phải chứa ít nhất một chữ cái viết thường" })
    .regex(/\d/, { message: "Mật khẩu phải chứa ít nhất một chữ số" })
    .regex(/[!@#$%^&*(),.?":{}|<>]/, { message: "Mật khẩu phải chứa ít nhất một ký tự đặc biệt" }),
  confirm_password: z.string().min(8, "Mật khẩu cũ phải có ít nhất 8 ký tự")
}).refine(data => data.new_password === data.confirm_password, { message: "Mật khẩu xác nhận không khớp", path: ["confirm_password"]})

export const schemaValidUser = z.object({
  username: z.string().min(1, "Tên đăng nhập không được để trống"),
  fullname: z.string().nullable().optional(),
  email: z
    .string()
    .email("Phải là email hợp lệ")
    .or(z.literal("")) // Chuỗi rỗng được phép
    .nullable() // null được phép
    .refine(
      (value) => value === null || value === "" || z.string().email().safeParse(value).success,
      {
        message: "Phải là email hợp lệ hoặc để trống",
      }
    ).optional(),
  avatar: z.string().nullable().optional(),
  giaovien_id: z.number().nullable().optional(),
});